<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <g v-if="weight === 'THIN'" mask="url(#mask-thin)">
            <path
                d="M4.23075 21.0001V10.2308H3V5.80782H8.14225C7.94358 5.63216 7.80608 5.42374 7.72975 5.18257C7.65358 4.94157 7.6155 4.68841 7.6155 4.42307C7.6155 3.76074 7.84733 3.19774 8.311 2.73407C8.77467 2.27041 9.33767 2.03857 10 2.03857C10.3833 2.03857 10.7353 2.12866 11.0558 2.30882C11.3763 2.48882 11.6525 2.72308 11.8845 3.01158C12.1167 2.71924 12.393 2.48399 12.7135 2.30582C13.034 2.12766 13.3859 2.03857 13.7693 2.03857C14.4316 2.03857 14.9946 2.27041 15.4583 2.73407C15.9219 3.19774 16.1538 3.76074 16.1538 4.42307C16.1538 4.68341 16.1147 4.93441 16.0365 5.17607C15.9583 5.41774 15.8218 5.62832 15.627 5.80782H21V10.2308H19.7693V21.0001H4.23075ZM13.7693 3.03857C13.3769 3.03857 13.0481 3.17124 12.7828 3.43658C12.5173 3.70191 12.3845 4.03074 12.3845 4.42307C12.3845 4.81541 12.5173 5.14424 12.7828 5.40957C13.0481 5.67508 13.3769 5.80782 13.7693 5.80782C14.1616 5.80782 14.4904 5.67508 14.7557 5.40957C15.0211 5.14424 15.1538 4.81541 15.1538 4.42307C15.1538 4.03074 15.0211 3.70191 14.7557 3.43658C14.4904 3.17124 14.1616 3.03857 13.7693 3.03857ZM8.6155 4.42307C8.6155 4.81541 8.74817 5.14424 9.0135 5.40957C9.27883 5.67508 9.60767 5.80782 10 5.80782C10.3923 5.80782 10.7212 5.67508 10.9865 5.40957C11.2518 5.14424 11.3845 4.81541 11.3845 4.42307C11.3845 4.03074 11.2518 3.70191 10.9865 3.43658C10.7212 3.17124 10.3923 3.03857 10 3.03857C9.60767 3.03857 9.27883 3.17124 9.0135 3.43658C8.74817 3.70191 8.6155 4.03074 8.6155 4.42307ZM4 6.80782V9.23082H11.5V6.80782H4ZM11.5 20.0001V10.2308H5.23075V20.0001H11.5ZM12.5 20.0001H18.7693V10.2308H12.5V20.0001ZM20 9.23082V6.80782H12.5V9.23082H20Z"
                fill="currentColor"
            />
            <mask
                id="mask-thin"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <g v-else-if="weight === 'REGULAR'" mask="url(#mask-regular)">
            <path
                d="M4.1155 21.4998V10.615H2.5V5.40379H7.67125C7.53025 5.24096 7.43442 5.05754 7.38375 4.85354C7.33308 4.64971 7.30775 4.43563 7.30775 4.21129C7.30775 3.46346 7.5695 2.82779 8.093 2.30429C8.6165 1.78079 9.25217 1.51904 10 1.51904C10.3833 1.51904 10.7385 1.59946 11.0655 1.76029C11.3923 1.92129 11.6846 2.13638 11.9423 2.40554C12.1999 2.12604 12.4923 1.90846 12.8193 1.75279C13.1461 1.59696 13.5012 1.51904 13.8845 1.51904C14.6325 1.51904 15.2682 1.78079 15.7917 2.30429C16.3153 2.82779 16.577 3.46346 16.577 4.21129C16.577 4.43313 16.5491 4.64404 16.4932 4.84404C16.4374 5.04404 16.3442 5.23063 16.2135 5.40379H21.5V10.615H19.8845V21.4998H4.1155ZM13.8845 3.01904C13.5467 3.01904 13.2635 3.13329 13.035 3.36179C12.8065 3.59029 12.6923 3.87346 12.6923 4.21129C12.6923 4.54913 12.8065 4.83229 13.035 5.06079C13.2635 5.28946 13.5467 5.40379 13.8845 5.40379C14.2223 5.40379 14.5056 5.28946 14.7343 5.06079C14.9628 4.83229 15.077 4.54913 15.077 4.21129C15.077 3.87346 14.9628 3.59029 14.7343 3.36179C14.5056 3.13329 14.2223 3.01904 13.8845 3.01904ZM8.80775 4.21129C8.80775 4.54913 8.922 4.83229 9.1505 5.06079C9.379 5.28946 9.66217 5.40379 10 5.40379C10.3378 5.40379 10.621 5.28946 10.8495 5.06079C11.078 4.83229 11.1923 4.54913 11.1923 4.21129C11.1923 3.87346 11.078 3.59029 10.8495 3.36179C10.621 3.13329 10.3378 3.01904 10 3.01904C9.66217 3.01904 9.379 3.13329 9.1505 3.36179C8.922 3.59029 8.80775 3.87346 8.80775 4.21129ZM4 6.90354V9.11529H11.25V6.90354H4ZM11.25 19.9998V10.615H5.61525V19.9998H11.25ZM12.75 19.9998H18.3848V10.615H12.75V19.9998ZM20 9.11529V6.90354H12.75V9.11529H20Z"
                fill="currentColor"
            />
            <mask
                id="mask-regular"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <g v-else mask="url(#mask-fill)">
            <path
                d="M4 13H11V22H4V13ZM20 22H13V13H20V22ZM14 1C14.8333 1 15.5417 1.29167 16.125 1.875C16.7083 2.45833 17 3.16667 17 4C17 4.18333 16.9835 4.35436 16.9502 4.5127C16.9169 4.67098 16.8665 4.83338 16.7998 5H22V11H13V5H11V11H2V5H7.2002C7.11692 4.8501 7.06213 4.69194 7.03711 4.52539C7.01211 4.35872 7 4.18333 7 4C7 3.16667 7.29167 2.45833 7.875 1.875C8.45833 1.29167 9.16667 1 10 1C10.3833 1 10.7419 1.07122 11.0752 1.21289C11.4084 1.35453 11.7168 1.54992 12 1.7998C12.2832 1.53325 12.5916 1.33351 12.9248 1.2002C13.2581 1.06686 13.6167 1 14 1ZM10 3C9.71667 3 9.47878 3.09544 9.28711 3.28711C9.09544 3.47878 9 3.71667 9 4C9 4.28333 9.09544 4.52122 9.28711 4.71289C9.47878 4.90456 9.71667 5 10 5C10.2833 5 10.5212 4.90456 10.7129 4.71289C10.9046 4.52122 11 4.28333 11 4C11 3.71667 10.9046 3.47878 10.7129 3.28711C10.5212 3.09544 10.2833 3 10 3ZM14 3C13.7167 3 13.4788 3.09544 13.2871 3.28711C13.0954 3.47878 13 3.71667 13 4C13 4.28333 13.0954 4.52122 13.2871 4.71289C13.4788 4.90456 13.7167 5 14 5C14.2833 5 14.5212 4.90456 14.7129 4.71289C14.9046 4.52122 15 4.28333 15 4C15 3.71667 14.9046 3.47878 14.7129 3.28711C14.5212 3.09544 14.2833 3 14 3Z"
                fill="currentColor"
            />
            <mask
                id="mask-fill"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'featured-seasonal-and-gifts-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>
